/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatchProductsRequestInnerAllOfSchedulesInnerDaysInner } from './PatchProductsRequestInnerAllOfSchedulesInnerDaysInner';
import {
    PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerFromJSON,
    PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerFromJSONTyped,
    PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerToJSON,
    PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerToJSONTyped,
} from './PatchProductsRequestInnerAllOfSchedulesInnerDaysInner';

/**
 * 
 * @export
 * @interface PatchOrganizationCombosRequestInnerAllOfSchedulesInner
 */
export interface PatchOrganizationCombosRequestInnerAllOfSchedulesInner {
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationCombosRequestInnerAllOfSchedulesInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationCombosRequestInnerAllOfSchedulesInner
     */
    comboId: string;
    /**
     * 
     * @type {Array<PatchProductsRequestInnerAllOfSchedulesInnerDaysInner>}
     * @memberof PatchOrganizationCombosRequestInnerAllOfSchedulesInner
     */
    days: Array<PatchProductsRequestInnerAllOfSchedulesInnerDaysInner>;
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationCombosRequestInnerAllOfSchedulesInner
     */
    hourFrom: string;
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationCombosRequestInnerAllOfSchedulesInner
     */
    hourTo: string;
}

/**
 * Check if a given object implements the PatchOrganizationCombosRequestInnerAllOfSchedulesInner interface.
 */
export function instanceOfPatchOrganizationCombosRequestInnerAllOfSchedulesInner(value: object): value is PatchOrganizationCombosRequestInnerAllOfSchedulesInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('comboId' in value) || value['comboId'] === undefined) return false;
    if (!('days' in value) || value['days'] === undefined) return false;
    if (!('hourFrom' in value) || value['hourFrom'] === undefined) return false;
    if (!('hourTo' in value) || value['hourTo'] === undefined) return false;
    return true;
}

export function PatchOrganizationCombosRequestInnerAllOfSchedulesInnerFromJSON(json: any): PatchOrganizationCombosRequestInnerAllOfSchedulesInner {
    return PatchOrganizationCombosRequestInnerAllOfSchedulesInnerFromJSONTyped(json, false);
}

export function PatchOrganizationCombosRequestInnerAllOfSchedulesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchOrganizationCombosRequestInnerAllOfSchedulesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'comboId': json['comboId'],
        'days': ((json['days'] as Array<any>).map(PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerFromJSON)),
        'hourFrom': json['hourFrom'],
        'hourTo': json['hourTo'],
    };
}

export function PatchOrganizationCombosRequestInnerAllOfSchedulesInnerToJSON(json: any): PatchOrganizationCombosRequestInnerAllOfSchedulesInner {
    return PatchOrganizationCombosRequestInnerAllOfSchedulesInnerToJSONTyped(json, false);
}

export function PatchOrganizationCombosRequestInnerAllOfSchedulesInnerToJSONTyped(value?: PatchOrganizationCombosRequestInnerAllOfSchedulesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'comboId': value['comboId'],
        'days': ((value['days'] as Array<any>).map(PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerToJSON)),
        'hourFrom': value['hourFrom'],
        'hourTo': value['hourTo'],
    };
}

